import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';
import { FileText, Download, Shield, Users, Scale, Cookie } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { complianceAPI, getUploadUrl } from '../services/api';
import { RichTextDisplay } from '../components/ui/rich-text-display';

const complianceConfig = {
  privacy: {
    icon: Shield,
    defaultTitle: 'Privacy Policy',
    defaultContent: `<h1>Privacy Policy di <strong>www.gmed.it</strong></h1>

<p>Questo Sito Web raccoglie alcuni Dati Personali dei propri Utenti.</p>

<p>Questo documento può essere stampato utilizzando il comando di stampa presente nelle impostazioni di qualsiasi browser.</p>

<h2>Titolare del Trattamento dei Dati</h2>

<p><strong>Gmed Srl</strong> - Via Selvamaggio, 19 - 53034 Colle di Val d'Elsa (SI) - Italia</p>
<p><strong>Indirizzo email del Titolare:</strong> dpo@gmed.it</p>

<h2>Tipologie di Dati raccolti</h2>

<p>Fra i Dati Personali raccolti da questo Sito Web, in modo autonomo o tramite terze parti, ci sono: email; nome; cognome; numero di telefono; Strumenti di Tracciamento; Dati comunicati durante l'utilizzo del servizio; Dati di utilizzo; informazioni sul browser; informazioni sul dispositivo.</p>

<p>Dettagli completi su ciascuna tipologia di Dati Personali raccolti sono forniti nelle sezioni dedicate di questa privacy policy o mediante specifici testi informativi visualizzati prima della raccolta dei Dati stessi.</p>

<p>I Dati Personali possono essere liberamente forniti dall'Utente o, nel caso di Dati di Utilizzo, raccolti automaticamente durante l'uso di questo Sito Web.</p>

<p>Se non diversamente specificato, tutti i Dati richiesti da questo Sito Web sono obbligatori. Se l'Utente rifiuta di comunicarli, potrebbe essere impossibile per questo Sito Web fornire il Servizio. Nei casi in cui questo Sito Web indichi alcuni Dati come facoltativi, gli Utenti sono liberi di astenersi dal comunicare tali Dati, senza che ciò abbia alcuna conseguenza sulla disponibilità del Servizio o sulla sua operatività.</p>

<p>Gli Utenti che dovessero avere dubbi su quali Dati siano obbligatori sono incoraggiati a contattare il Titolare.</p>

<p>L'eventuale utilizzo di Cookie - o di altri strumenti di tracciamento - da parte di questo Sito Web o dei titolari dei servizi terzi utilizzati da questo Sito Web ha la finalità di fornire il Servizio richiesto dall'Utente, oltre alle ulteriori finalità descritte nel presente documento e nella Cookie Policy.</p>

<p>L'Utente si assume la responsabilità dei Dati Personali di terzi ottenuti, pubblicati o condivisi mediante questo Sito Web.</p>

<h2>Modalità e luogo del trattamento dei Dati raccolti</h2>

<h3>Modalità di trattamento</h3>

<p>Il Titolare adotta le opportune misure di sicurezza volte ad impedire l'accesso, la divulgazione, la modifica o la distruzione non autorizzate dei Dati Personali.</p>

<p>Il trattamento viene effettuato mediante strumenti informatici e/o telematici, con modalità organizzative e con logiche strettamente correlate alle finalità indicate. Oltre al Titolare, in alcuni casi, potrebbero avere accesso ai Dati altri soggetti coinvolti nell'organizzazione di questo Sito Web (personale amministrativo, commerciale, marketing, legali, amministratori di sistema) ovvero soggetti esterni (come fornitori di servizi tecnici terzi, corrieri postali, hosting provider, società informatiche, agenzie di comunicazione) nominati anche, se necessario, Responsabili del Trattamento da parte del Titolare. L'elenco aggiornato dei Responsabili potrà sempre essere richiesto al Titolare del Trattamento.</p>

<h3>Luogo</h3>

<p>I Dati sono trattati presso le sedi operative del Titolare ed in ogni altro luogo in cui le parti coinvolte nel trattamento siano localizzate. Per ulteriori informazioni, contatta il Titolare.</p>

<p>I Dati Personali dell'Utente potrebbero essere trasferiti in un paese diverso da quello in cui l'Utente si trova. Per ottenere ulteriori informazioni sul luogo del trattamento l'Utente può fare riferimento alla sezione relativa ai dettagli sul trattamento dei Dati Personali.</p>

<h3>Periodo di conservazione</h3>

<p>Se non diversamente indicato in questo documento, i Dati Personali sono trattati e conservati per il tempo richiesto dalla finalità per la quale sono stati raccolti e potrebbero essere conservati per un periodo più lungo a causa di eventuali obbligazioni legali o sulla base del consenso degli Utenti.</p>

<h2>Finalità del Trattamento dei Dati raccolti</h2>

<p>I Dati dell'Utente sono raccolti per consentire al Titolare di fornire il Servizio, adempiere agli obblighi di legge, rispondere a richieste o azioni esecutive, tutelare i propri diritti ed interessi (o quelli di Utenti o di terze parti), individuare eventuali attività dolose o fraudolente, nonché per le seguenti finalità: Contattare l'Utente, Gestione dei tag, Hosting ed infrastruttura backend, Protezione dallo SPAM, Statistica, Visualizzazione di contenuti da piattaforme esterne.</p>

<h2>Dettagli sul trattamento dei Dati Personali</h2>

<p>I Dati Personali sono raccolti per le seguenti finalità ed utilizzando i seguenti servizi:</p>

<h3>Contattare l'Utente</h3>

<h4>Modulo di contatto (questo Sito Web)</h4>
<p>L'Utente, compilando con i propri Dati il modulo di contatto, acconsente al loro utilizzo per rispondere alle richieste di informazioni, di preventivo, o di qualunque altra natura indicata dall'intestazione del modulo.</p>
<p><strong>Dati Personali trattati:</strong> cognome; email; nome; numero di telefono.</p>

<h3>Hosting ed infrastruttura backend</h3>

<h4>Emergent Cloud Hosting</h4>
<p>Il sito web è ospitato su infrastruttura cloud gestita da Emergent. I dati sono conservati su server situati nell'Unione Europea.</p>
<p><strong>Dati Personali trattati:</strong> Dati di utilizzo, log di accesso e dati tecnici necessari all'erogazione del servizio.</p>
<p><strong>Luogo del trattamento:</strong> UE</p>

<h4>Amazon Web Services S3 (AWS)</h4>
<p>Amazon Web Services S3 è un servizio di storage cloud fornito da Amazon Web Services, Inc., utilizzato per la conservazione di file caricati sul sito (immagini, documenti).</p>
<p><strong>Dati Personali trattati:</strong> file caricati dagli utenti.</p>
<p><strong>Luogo del trattamento:</strong> UE - <a href="https://aws.amazon.com/it/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy AWS</a></p>

<h3>Protezione dallo SPAM</h3>

<h4>Google reCAPTCHA (Google Ireland Limited)</h4>
<p>Google reCAPTCHA è un servizio di protezione dallo SPAM fornito da Google Ireland Limited.</p>
<p><strong>Dati Personali trattati:</strong> clic; Dati di utilizzo; eventi touch; movimenti del mouse; Strumenti di Tracciamento.</p>
<p><strong>Luogo del trattamento:</strong> Irlanda - <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a></p>

<h3>Statistica</h3>

<h4>PostHog</h4>
<p>PostHog è un servizio di analisi web che permette di monitorare e analizzare i dati di traffico.</p>
<p><strong>Dati Personali trattati:</strong> Dati di utilizzo; Strumenti di Tracciamento.</p>
<p><strong>Luogo del trattamento:</strong> UE - <a href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy PostHog</a></p>

<h3>Visualizzazione di contenuti da piattaforme esterne</h3>

<h4>Google Fonts (Google Ireland Limited)</h4>
<p>Google Fonts è un servizio di visualizzazione di stili di carattere gestito da Google Ireland Limited che permette a questo Sito Web di integrare tali contenuti all'interno delle proprie pagine.</p>
<p><strong>Dati Personali trattati:</strong> Dati di utilizzo; Strumenti di Tracciamento.</p>
<p><strong>Luogo del trattamento:</strong> Irlanda - <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></p>

<h2>Cookie Policy</h2>

<p>Questo Sito Web fa utilizzo di Strumenti di Tracciamento. Per saperne di più, gli Utenti possono consultare la <a href="/compliance/cookie-policy">Cookie Policy</a>.</p>

<h2>Ulteriori informazioni per gli utenti</h2>

<h3>Base giuridica del trattamento</h3>

<p>Il Titolare tratta Dati Personali relativi all'Utente in caso sussista una delle seguenti condizioni:</p>
<ul>
<li>l'Utente ha prestato il consenso per una o più finalità specifiche;</li>
<li>il trattamento è necessario all'esecuzione di un contratto con l'Utente e/o all'esecuzione di misure precontrattuali;</li>
<li>il trattamento è necessario per adempiere un obbligo legale al quale è soggetto il Titolare;</li>
<li>il trattamento è necessario per l'esecuzione di un compito di interesse pubblico o per l'esercizio di pubblici poteri di cui è investito il Titolare;</li>
<li>il trattamento è necessario per il perseguimento del legittimo interesse del Titolare o di terzi.</li>
</ul>

<p>È comunque sempre possibile richiedere al Titolare di chiarire la concreta base giuridica di ciascun trattamento ed in particolare di specificare se il trattamento sia basato sulla legge, previsto da un contratto o necessario per concludere un contratto.</p>

<h3>Ulteriori informazioni sul tempo di conservazione</h3>

<p>Se non diversamente indicato in questo documento, i Dati Personali sono trattati e conservati per il tempo richiesto dalla finalità per la quale sono stati raccolti e potrebbero essere conservati per un periodo più lungo a causa di eventuali obbligazioni legali o sulla base del consenso degli Utenti.</p>

<p>Pertanto:</p>
<ul>
<li>I Dati Personali raccolti per scopi collegati all'esecuzione di un contratto tra il Titolare e l'Utente saranno trattenuti sino a quando sia completata l'esecuzione di tale contratto.</li>
<li>I Dati Personali raccolti per finalità riconducibili all'interesse legittimo del Titolare saranno trattenuti sino al soddisfacimento di tale interesse.</li>
</ul>

<p>Quando il trattamento è basato sul consenso dell'Utente, il Titolare può conservare i Dati Personali più a lungo sino a quando detto consenso non venga revocato. Inoltre, il Titolare potrebbe essere obbligato a conservare i Dati Personali per un periodo più lungo per adempiere ad un obbligo di legge o per ordine di un'autorità.</p>

<p>Al termine del periodo di conservazione i Dati Personali saranno cancellati. Pertanto, allo spirare di tale termine il diritto di accesso, cancellazione, rettificazione ed il diritto alla portabilità dei Dati non potranno più essere esercitati.</p>

<h3>Diritti dell'Utente sulla base del Regolamento Generale sulla Protezione dei Dati (GDPR)</h3>

<p>Gli Utenti possono esercitare determinati diritti con riferimento ai Dati trattati dal Titolare.</p>

<p>In particolare, nei limiti previsti dalla legge, l'Utente ha il diritto di:</p>
<ul>
<li><strong>revocare il consenso in ogni momento.</strong> L'Utente può revocare il consenso al trattamento dei propri Dati Personali precedentemente espresso.</li>
<li><strong>opporsi al trattamento dei propri Dati.</strong> L'Utente può opporsi al trattamento dei propri Dati quando esso avviene in virtù di una base giuridica diversa dal consenso.</li>
<li><strong>accedere ai propri Dati.</strong> L'Utente ha diritto ad ottenere informazioni sui Dati trattati dal Titolare, su determinati aspetti del trattamento ed a ricevere una copia dei Dati trattati.</li>
<li><strong>verificare e chiedere la rettificazione.</strong> L'Utente può verificare la correttezza dei propri Dati e richiederne l'aggiornamento o la correzione.</li>
<li><strong>ottenere la limitazione del trattamento.</strong> L'Utente può richiedere la limitazione del trattamento dei propri Dati. In tal caso il Titolare non tratterà i Dati per alcun altro scopo se non la loro conservazione.</li>
<li><strong>ottenere la cancellazione o rimozione dei propri Dati Personali.</strong> L'Utente può richiedere la cancellazione dei propri Dati da parte del Titolare.</li>
<li><strong>ricevere i propri Dati o farli trasferire ad altro titolare.</strong> L'Utente ha diritto di ricevere i propri Dati in formato strutturato, di uso comune e leggibile da dispositivo automatico e, ove tecnicamente fattibile, di ottenerne il trasferimento senza ostacoli ad un altro titolare.</li>
<li><strong>proporre reclamo.</strong> L'Utente può proporre un reclamo all'autorità di controllo della protezione dei dati personali competente o agire in sede giudiziale.</li>
</ul>

<h4>Dettagli sul diritto di opposizione</h4>

<p><strong>Quando i Dati Personali sono trattati nell'interesse pubblico, nell'esercizio di pubblici poteri di cui è investito il Titolare oppure per perseguire un interesse legittimo del Titolare, gli Utenti hanno diritto ad opporsi al trattamento per motivi connessi alla loro situazione particolare.</strong></p>

<p><strong>Si fa presente agli Utenti che, ove i loro Dati fossero trattati con finalità di marketing diretto, possono opporsi al trattamento in qualsiasi momento, gratuitamente e senza fornire alcuna motivazione.</strong></p>

<h4>Come esercitare i diritti</h4>

<p>Eventuali richieste di esercizio dei diritti dell'Utente possono essere indirizzate al Titolare attraverso i recapiti forniti in questo documento. La richiesta è gratuita e il Titolare risponderà nel più breve tempo possibile, in ogni caso entro un mese, fornendo all'Utente tutte le informazioni previste dalla legge.</p>

<h2>Ulteriori informazioni sul trattamento</h2>

<h3>Difesa in giudizio</h3>

<p>I Dati Personali dell'Utente possono essere utilizzati da parte del Titolare in giudizio o nelle fasi preparatorie alla sua eventuale instaurazione per la difesa da abusi nell'utilizzo di questo Sito Web o dei Servizi connessi da parte dell'Utente.</p>

<p>L'Utente dichiara di essere consapevole che il Titolare potrebbe essere obbligato a rivelare i Dati per ordine delle autorità pubbliche.</p>

<h3>Informative specifiche</h3>

<p>Su richiesta dell'Utente, in aggiunta alle informazioni contenute in questa privacy policy, questo Sito Web potrebbe fornire all'Utente delle informative aggiuntive e contestuali riguardanti Servizi specifici, o la raccolta ed il trattamento di Dati Personali.</p>

<h3>Log di sistema e manutenzione</h3>

<p>Per necessità legate al funzionamento ed alla manutenzione, questo Sito Web e gli eventuali servizi terzi da essa utilizzati potrebbero raccogliere log di sistema, ossia file che registrano le interazioni e che possono contenere anche Dati Personali, quali l'indirizzo IP Utente.</p>

<h3>Informazioni non contenute in questa policy</h3>

<p>Ulteriori informazioni in relazione al trattamento dei Dati Personali potranno essere richieste in qualsiasi momento al Titolare del Trattamento utilizzando gli estremi di contatto.</p>

<h3>Modifiche a questa privacy policy</h3>

<p>Il Titolare del Trattamento si riserva il diritto di apportare modifiche alla presente privacy policy in qualunque momento notificandolo agli Utenti su questa pagina e, se possibile, su questo Sito Web nonché, qualora tecnicamente e legalmente fattibile, inviando una notifica agli Utenti attraverso uno degli estremi di contatto di cui è in possesso. Si prega dunque di consultare con frequenza questa pagina, facendo riferimento alla data di ultima modifica indicata in fondo.</p>

<h2>Definizioni e riferimenti legali</h2>

<h4>Dati Personali (o Dati)</h4>
<p>Costituisce dato personale qualunque informazione che, direttamente o indirettamente, anche in collegamento con qualsiasi altra informazione, ivi compreso un numero di identificazione personale, renda identificata o identificabile una persona fisica.</p>

<h4>Dati di Utilizzo</h4>
<p>Sono le informazioni raccolte automaticamente attraverso questo Sito Web (anche da applicazioni di parti terze integrate in questo Sito Web), tra cui: gli indirizzi IP o i nomi a dominio dei computer utilizzati dall'Utente che si connette con questo Sito Web, gli indirizzi in notazione URI (Uniform Resource Identifier), l'orario della richiesta, il metodo utilizzato nell'inoltrare la richiesta al server, la dimensione del file ottenuto in risposta, il codice numerico indicante lo stato della risposta dal server (buon fine, errore, ecc.) il paese di provenienza, le caratteristiche del browser e del sistema operativo utilizzati dal visitatore, le varie connotazioni temporali della visita (ad esempio il tempo di permanenza su ciascuna pagina) e i dettagli relativi all'itinerario seguito all'interno dell'Applicazione.</p>

<h4>Utente</h4>
<p>L'individuo che utilizza questo Sito Web che, salvo ove diversamente specificato, coincide con l'Interessato.</p>

<h4>Interessato</h4>
<p>La persona fisica cui si riferiscono i Dati Personali.</p>

<h4>Responsabile del Trattamento (o Responsabile)</h4>
<p>La persona fisica, giuridica, la pubblica amministrazione e qualsiasi altro ente che tratta dati personali per conto del Titolare, secondo quanto esposto nella presente privacy policy.</p>

<h4>Titolare del Trattamento (o Titolare)</h4>
<p>La persona fisica o giuridica, l'autorità pubblica, il servizio o altro organismo che, singolarmente o insieme ad altri, determina le finalità e i mezzi del trattamento di dati personali e gli strumenti adottati, ivi comprese le misure di sicurezza relative al funzionamento ed alla fruizione di questo Sito Web. Il Titolare del Trattamento, salvo quanto diversamente specificato, è il titolare di questo Sito Web.</p>

<h4>Questo Sito Web (o questa Applicazione)</h4>
<p>Lo strumento hardware o software mediante il quale sono raccolti e trattati i Dati Personali degli Utenti.</p>

<h4>Servizio</h4>
<p>Il Servizio fornito da questo Sito Web così come definito nei relativi termini (se presenti) su questo sito/applicazione.</p>

<h4>Unione Europea (o UE)</h4>
<p>Salvo ove diversamente specificato, ogni riferimento all'Unione Europea contenuto in questo documento si intende esteso a tutti gli attuali stati membri dell'Unione Europea e dello Spazio Economico Europeo.</p>

<h4>Cookie</h4>
<p>I Cookie sono Strumenti di Tracciamento che consistono in piccole porzioni di dati conservate all'interno del browser dell'Utente.</p>

<h4>Strumento di Tracciamento</h4>
<p>Per Strumento di Tracciamento s'intende qualsiasi tecnologia - es. Cookie, identificativi univoci, web beacons, script integrati, e-tag e fingerprinting - che consenta di tracciare gli Utenti, per esempio raccogliendo o salvando informazioni sul dispositivo dell'Utente.</p>

<hr/>

<h4>Riferimenti legali</h4>
<p>Ove non diversamente specificato, questa policy riguarda esclusivamente questo Sito Web.</p>

<p><strong>Ultima modifica: 27 febbraio 2025</strong></p>`,
    color: 'from-blue-500 to-blue-600'
  },
  dpo: {
    icon: Users,
    defaultTitle: 'Responsabile Protezione Dati',
    defaultContent: 'Il Responsabile della Protezione dei Dati (DPO) è la figura incaricata di garantire il rispetto della normativa sulla protezione dei dati personali all\'interno della nostra organizzazione.',
    color: 'from-green-500 to-green-600'
  },
  'gender-equality': {
    icon: Scale,
    defaultTitle: 'Parità di Genere',
    defaultContent: 'Il nostro impegno per la parità di genere si concretizza in politiche aziendali volte a garantire pari opportunità e valorizzare le diversità nel luogo di lavoro.',
    color: 'from-purple-500 to-purple-600'
  },
  'cookie-policy': {
    icon: Cookie,
    defaultTitle: 'Cookie Policy',
    defaultContent: `<h1>Cookie Policy di <strong>www.gmed.it</strong></h1>

<p>Questo documento contiene informazioni in merito alle tecnologie che consentono a questo Sito Web di raggiungere gli scopi descritti di seguito. Tali tecnologie permettono al Titolare di raccogliere e salvare informazioni (per esempio tramite l'utilizzo di Cookie) o di utilizzare risorse (per esempio eseguendo uno script) sul dispositivo dell'Utente quando quest'ultimo interagisce con questo Sito Web.</p>

<p>Per semplicità, in questo documento tali tecnologie sono sinteticamente definite "Strumenti di Tracciamento", salvo vi sia ragione di differenziare.</p>

<p>Per esempio, sebbene i Cookie possano essere usati in browser sia web sia mobili, sarebbe fuori luogo parlare di Cookie nel contesto di applicazioni per dispositivi mobili, dal momento che si tratta di Strumenti di Tracciamento che richiedono la presenza di un browser. Per questo motivo, all'interno di questo documento il termine Cookie è utilizzato solo per indicare in modo specifico quel particolare tipo di Strumento di Tracciamento.</p>

<p>Alcune delle finalità per le quali vengono impiegati Strumenti di Tracciamento potrebbero, inoltre richiedere il consenso dell'Utente. Se viene prestato il consenso, esso può essere revocato liberamente in qualsiasi momento seguendo le istruzioni contenute in questo documento.</p>

<p>Questo Sito Web utilizza Strumenti di Tracciamento gestiti direttamente dal Titolare (comunemente detti Strumenti di Tracciamento "di prima parte") e Strumenti di Tracciamento che abilitano servizi forniti da terzi (comunemente detti Strumenti di Tracciamento "di terza parte"). Se non diversamente specificato all'interno di questo documento, tali terzi hanno accesso ai rispettivi Strumenti di Tracciamento.</p>

<p>Durata e scadenza dei Cookie e degli altri Strumenti di Tracciamento simili possono variare a seconda di quanto impostato dal Titolare o da ciascun fornitore terzo. Alcuni di essi scadono al termine della sessione di navigazione dell'Utente.</p>

<h2>Come questo Sito Web utilizza gli Strumenti di Tracciamento</h2>

<h3>Cookie Necessari (Tecnici)</h3>

<p>Questo Sito Web utilizza Cookie comunemente detti "tecnici" o altri Strumenti di Tracciamento analoghi per svolgere attività strettamente necessarie a garantire il funzionamento o la fornitura del Servizio.</p>

<h4>Cookie di prima parte</h4>
<table>
<tr><th>Nome</th><th>Finalità</th><th>Durata</th></tr>
<tr><td>gmed_admin_token</td><td>Autenticazione area amministrativa</td><td>7 giorni</td></tr>
<tr><td>gmed_cookie_consent</td><td>Memorizzazione preferenze cookie</td><td>1 anno</td></tr>
<tr><td>gmed-theme</td><td>Preferenza tema (chiaro/scuro)</td><td>1 anno</td></tr>
<tr><td>i18nextLng</td><td>Preferenza lingua (IT/EN)</td><td>1 anno</td></tr>
</table>

<p><em>Base giuridica:</em> legittimo interesse del Titolare (art. 6.1.f GDPR) - questi cookie sono strettamente necessari al funzionamento del sito.</p>

<p><em>Nota: <code>gmed_cookie_consent</code>, <code>gmed-theme</code> e <code>i18nextLng</code> sono salvati nella memoria locale del browser (localStorage) e non vengono trasmessi al server; <code>gmed_admin_token</code> è utilizzato esclusivamente per l'accesso all'area amministrativa riservata.</em></p>

<h3>Cookie di Esperienza</h3>

<p>Questo Sito Web utilizza Strumenti di Tracciamento per migliorare la qualità della user experience e consentire le interazioni con contenuti, network e piattaforme esterni.</p>

<h5>Google Fonts (Google Ireland Limited)</h5>
<p>Google Fonts è un servizio di visualizzazione di stili di carattere gestito da Google Ireland Limited che permette a questo Sito Web di integrare tali contenuti all'interno delle proprie pagine.</p>
<p><strong>Dati Personali trattati:</strong> Dati di utilizzo e Strumenti di Tracciamento.</p>
<p><strong>Luogo del trattamento:</strong> Irlanda - <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Privacy Policy</a></p>

<h3>Cookie di Misurazione (Analitici)</h3>

<p>Questo Sito Web utilizza Strumenti di Tracciamento per misurare il traffico e analizzare il comportamento degli Utenti con l'obiettivo di migliorare il Servizio.</p>

<h5>PostHog</h5>
<p>PostHog è un servizio di analisi web che permette di monitorare e analizzare i dati di traffico e il comportamento degli utenti. I dati raccolti vengono utilizzati per migliorare l'esperienza utente sul sito.</p>
<p><strong>Dati Personali trattati:</strong> Dati di utilizzo, informazioni sul browser, informazioni sul dispositivo e Strumenti di Tracciamento.</p>
<p><strong>Luogo del trattamento:</strong> UE - <a href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy PostHog</a></p>

<h6>Registrazione della sessione (Session Recording / Session Replay)</h6>
<p>Se acconsenti ai cookie analitici, PostHog attiva anche la <strong>registrazione della sessione di navigazione</strong>: viene ricostruita la tua interazione con le pagine (movimenti e clic del mouse, scroll, tocchi su schermo, digitazioni nei campi non sensibili, sequenza delle pagine visitate, dimensione della finestra, errori di caricamento). La registrazione non è un video dello schermo ma una riproduzione tecnica degli eventi del browser.</p>
<p><strong>Finalità:</strong> individuare difficoltà di utilizzo e malfunzionamenti dell'interfaccia, migliorare navigazione, form e accessibilità del sito.</p>
<p><strong>Base giuridica:</strong> <strong>consenso</strong> dell'Utente (art. 6.1.a GDPR), prestato tramite il pannello delle preferenze cookie. La registrazione <strong>non viene avviata in alcun caso prima del consenso</strong> (lo strumento è caricato con la registrazione disattivata) e si interrompe immediatamente alla revoca.</p>
<p><strong>Dati esclusi:</strong> i campi password sono sempre mascherati; ti invitiamo comunque a non inserire dati non necessari nei campi liberi.</p>
<p><strong>Revoca:</strong> in qualsiasi momento tramite il link "Gestisci cookie" presente nel footer del sito, disattivando i cookie analitici.</p>

<p><strong>Durata degli Strumenti di Tracciamento PostHog:</strong></p>
<table>
<thead><tr><th>Nome</th><th>Finalità</th><th>Durata</th></tr></thead>
<tbody>
<tr><td>ph_phc_*_posthog</td><td>Identificativo pseudonimo del visitatore e proprietà della sessione</td><td>12 mesi (365 giorni)</td></tr>
<tr><td>__ph_opt_in_out_phc_*</td><td>Memorizza la scelta di attivazione/disattivazione degli analitici</td><td>12 mesi (365 giorni)</td></tr>
<tr><td>ph_phc_*_posthog (session id)</td><td>Identificativo della singola sessione e della relativa registrazione</td><td>Sessione: 30 minuti di inattività, massimo 24 ore</td></tr>
</tbody>
</table>
<p><em>Base giuridica:</em> consenso dell'utente (art. 6.1.a GDPR). In assenza di consenso nessuno script PostHog viene caricato e nessun cookie <code>ph_*</code> o <code>__ph_*</code> viene impostato.</p>

<h3>Hosting ed infrastruttura backend</h3>

<h5>Emergent Cloud Hosting</h5>
<p>Il sito web è ospitato su infrastruttura cloud gestita da Emergent. I dati sono conservati su server situati nell'Unione Europea.</p>
<p><strong>Dati Personali trattati:</strong> Dati di utilizzo, log di accesso e dati tecnici necessari all'erogazione del servizio.</p>
<p><strong>Luogo del trattamento:</strong> UE</p>

<h5>Amazon Web Services S3 (AWS)</h5>
<p>Amazon Web Services S3 è un servizio di storage cloud fornito da Amazon Web Services, Inc., utilizzato per la conservazione di file caricati sul sito (immagini, documenti).</p>
<p><strong>Dati Personali trattati:</strong> file caricati dagli utenti.</p>
<p><strong>Luogo del trattamento:</strong> UE - <a href="https://aws.amazon.com/it/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy AWS</a></p>

<h2>Come gestire le preferenze e prestare o revocare il consenso</h2>

<p>Qualora l'utilizzo degli Strumenti di Tracciamento sia basato sul consenso, l'Utente può fornire o revocare tale consenso impostando o aggiornando le proprie preferenze tramite il relativo pannello delle scelte (cookie banner) disponibile su questo Sito Web al primo accesso. Il pannello è sempre richiamabile tramite il link <strong>"Gestisci cookie"</strong> presente nel footer di ogni pagina.</p>

<p>Per quanto riguarda Strumenti di Tracciamento di terza parte, gli Utenti possono gestire le proprie preferenze visitando il relativo link di opt out (qualora disponibile), utilizzando gli strumenti descritti nella privacy policy della terza parte o contattando quest'ultima direttamente.</p>

<h3>Come controllare o eliminare Cookie tramite le impostazioni del browser</h3>

<p>Gli Utenti possono utilizzare le impostazioni del proprio browser per:</p>
<ul>
<li>Vedere quali Cookie sono stati impostati sul dispositivo;</li>
<li>Bloccare Cookie;</li>
<li>Cancellare i Cookie dal browser.</li>
</ul>

<p>Gli Utenti possono trovare informazioni su come gestire i Cookie nei browser più diffusi ai seguenti indirizzi:</p>
<ul>
<li><a href="https://support.google.com/chrome/answer/95647?hl=it" target="_blank" rel="noopener">Google Chrome</a></li>
<li><a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank" rel="noopener">Mozilla Firefox</a></li>
<li><a href="https://support.apple.com/it-it/guide/safari/manage-cookies-and-website-data-sfri11471/" target="_blank" rel="noopener">Apple Safari</a></li>
<li><a href="https://support.microsoft.com/it-it/help/4027947" target="_blank" rel="noopener">Microsoft Edge</a></li>
<li><a href="https://help.opera.com/latest/web-preferences/#cookies" target="_blank" rel="noopener">Opera</a></li>
</ul>

<h3>Conseguenze legate al rifiuto dell'utilizzo di Strumenti di Tracciamento</h3>

<p>Gli Utenti sono liberi di decidere se permettere o meno l'utilizzo di Strumenti di Tracciamento. Tuttavia, si noti che gli Strumenti di Tracciamento consentono a questo Sito Web di fornire agli Utenti un'esperienza migliore e funzionalità avanzate (in linea con le finalità delineate nel presente documento). Pertanto, qualora l'Utente decida di bloccare l'utilizzo di Strumenti di Tracciamento, il Titolare potrebbe non essere in grado di fornire le relative funzionalità.</p>

<h2>Titolare del Trattamento dei Dati</h2>

<p><strong>Gmed Srl</strong><br/>
Via Selvamaggio, 19<br/>
53034 - Colle di Val d'Elsa (SI) - Italia</p>
<p><strong>Indirizzo email del Titolare:</strong> dpo@gmed.it</p>

<p>Dal momento che l'uso di Strumenti di Tracciamento di terza parte su questo Sito Web non può essere completamente controllato dal Titolare, ogni riferimento specifico a Strumenti di Tracciamento di terza parte è da considerarsi indicativo. Per ottenere informazioni complete, gli Utenti sono gentilmente invitati a consultare la privacy policy dei rispettivi servizi terzi elencati in questo documento.</p>

<h2>Definizioni e riferimenti legali</h2>

<h4>Dati Personali (o Dati)</h4>
<p>Costituisce dato personale qualunque informazione che, direttamente o indirettamente, anche in collegamento con qualsiasi altra informazione, ivi compreso un numero di identificazione personale, renda identificata o identificabile una persona fisica.</p>

<h4>Dati di Utilizzo</h4>
<p>Sono le informazioni raccolte automaticamente attraverso questo Sito Web (anche da applicazioni di parti terze integrate in questo Sito Web), tra cui: gli indirizzi IP o i nomi a dominio dei computer utilizzati dall'Utente che si connette con questo Sito Web, gli indirizzi in notazione URI (Uniform Resource Identifier), l'orario della richiesta, il metodo utilizzato nell'inoltrare la richiesta al server, la dimensione del file ottenuto in risposta, il codice numerico indicante lo stato della risposta dal server (buon fine, errore, ecc.) il paese di provenienza, le caratteristiche del browser e del sistema operativo utilizzati dal visitatore, le varie connotazioni temporali della visita (ad esempio il tempo di permanenza su ciascuna pagina) e i dettagli relativi all'itinerario seguito all'interno dell'Applicazione.</p>

<h4>Utente</h4>
<p>L'individuo che utilizza questo Sito Web che, salvo ove diversamente specificato, coincide con l'Interessato.</p>

<h4>Interessato</h4>
<p>La persona fisica cui si riferiscono i Dati Personali.</p>

<h4>Responsabile del Trattamento (o Responsabile)</h4>
<p>La persona fisica, giuridica, la pubblica amministrazione e qualsiasi altro ente che tratta dati personali per conto del Titolare, secondo quanto esposto nella presente privacy policy.</p>

<h4>Titolare del Trattamento (o Titolare)</h4>
<p>La persona fisica o giuridica, l'autorità pubblica, il servizio o altro organismo che, singolarmente o insieme ad altri, determina le finalità e i mezzi del trattamento di dati personali e gli strumenti adottati, ivi comprese le misure di sicurezza relative al funzionamento ed alla fruizione di questo Sito Web. Il Titolare del Trattamento, salvo quanto diversamente specificato, è il titolare di questo Sito Web.</p>

<h4>Questo Sito Web (o questa Applicazione)</h4>
<p>Lo strumento hardware o software mediante il quale sono raccolti e trattati i Dati Personali degli Utenti.</p>

<h4>Servizio</h4>
<p>Il Servizio fornito da questo Sito Web così come definito nei relativi termini (se presenti) su questo sito/applicazione.</p>

<h4>Unione Europea (o UE)</h4>
<p>Salvo ove diversamente specificato, ogni riferimento all'Unione Europea contenuto in questo documento si intende esteso a tutti gli attuali stati membri dell'Unione Europea e dello Spazio Economico Europeo.</p>

<h4>Cookie</h4>
<p>I Cookie sono Strumenti di Tracciamento che consistono in piccole porzioni di dati conservate all'interno del browser dell'Utente.</p>

<h4>Strumento di Tracciamento</h4>
<p>Per Strumento di Tracciamento s'intende qualsiasi tecnologia - es. Cookie, identificativi univoci, web beacons, script integrati, e-tag e fingerprinting - che consenta di tracciare gli Utenti, per esempio raccogliendo o salvando informazioni sul dispositivo dell'Utente.</p>

<hr/>

<h4>Riferimenti legali</h4>
<p>Ove non diversamente specificato, questa informativa riguarda esclusivamente questo Sito Web.</p>

<p><strong>Ultima modifica: 21 giugno 2026</strong></p>`,
    color: 'from-amber-500 to-amber-600'
  },
  'privacy-candidati': {
    icon: Users,
    defaultTitle: 'Informativa Privacy Candidati',
    defaultContent: `<h2>Informativa sul Trattamento dei Dati Personali per Candidati</h2>
<p>Ai sensi dell'art. 13 del Regolamento UE 2016/679 (GDPR)</p>

<h3>Titolare del Trattamento</h3>
<p><strong>Gmed Srl</strong><br/>
Strada di Selvamaggio, 19<br/>
53034 - Colle di Val d'Elsa (SI)<br/>
P.IVA: 01203470529<br/>
Email: dpo@gmed.it</p>

<h3>Finalità del Trattamento</h3>
<p>I dati personali forniti saranno trattati per le seguenti finalità:</p>
<ul>
<li>Valutazione della candidatura in relazione alle posizioni aperte</li>
<li>Gestione del processo di selezione del personale</li>
<li>Eventuale conservazione del CV per future opportunità lavorative</li>
<li>Adempimento degli obblighi di legge</li>
</ul>

<h3>Base Giuridica</h3>
<p>Il trattamento è basato su:</p>
<ul>
<li>Consenso dell'interessato (art. 6.1.a GDPR)</li>
<li>Esecuzione di misure precontrattuali (art. 6.1.b GDPR)</li>
</ul>

<h3>Dati Trattati</h3>
<ul>
<li>Dati anagrafici (nome, cognome)</li>
<li>Dati di contatto (email, telefono)</li>
<li>Dati contenuti nel curriculum vitae</li>
<li>Informazioni relative all'esperienza professionale e formazione</li>
</ul>

<h3>Periodo di Conservazione</h3>
<p>I dati saranno conservati per un periodo massimo di 24 mesi dalla ricezione della candidatura, salvo diversa indicazione o revoca del consenso.</p>

<h3>Destinatari dei Dati</h3>
<p>I dati potranno essere comunicati a:</p>
<ul>
<li>Personale interno autorizzato al trattamento</li>
<li>Eventuali consulenti esterni per la selezione del personale</li>
<li>Autorità competenti, se richiesto dalla legge</li>
</ul>

<h3>Diritti dell'Interessato</h3>
<p>L'interessato ha diritto di:</p>
<ul>
<li>Accedere ai propri dati personali</li>
<li>Richiedere la rettifica o la cancellazione</li>
<li>Limitare o opporsi al trattamento</li>
<li>Revocare il consenso in qualsiasi momento</li>
<li>Proporre reclamo all'Autorità Garante</li>
</ul>

<h3>Conferimento dei Dati</h3>
<p>Il conferimento dei dati è facoltativo ma necessario per la valutazione della candidatura. Il mancato conferimento comporterà l'impossibilità di procedere con la selezione.</p>`,
    color: 'from-teal-500 to-teal-600'
  },
  whistleblowing: {
    icon: Shield,
    defaultTitle: 'Informativa Whistleblowing',
    defaultContent: `<h2>Informativa sul trattamento dei dati nelle segnalazioni</h2>
<p>Informativa resa ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 e dell'art. 13 del D.Lgs. 24/2023.</p>
<p>Il testo completo è pubblicato in questa pagina ed è richiamato nel modulo di segnalazione. Se vedi questo messaggio, il contenuto non è ancora stato pubblicato dall'area amministrativa: puoi comunque inviare una segnalazione dalla pagina <a href="/whistleblowing">Whistleblowing</a>.</p>`,
    color: 'from-red-500 to-red-600'
  },
  'whistleblowing-info': {
    icon: Shield,
    minStored: 1,
    defaultTitle: 'Whistleblowing: cos\'è e come segnalare',
    defaultContent: `<h2>Cos'è il Whistleblowing</h2>
<p>Strumento per segnalare in modo riservato e protetto condotte illecite, irregolarità o violazioni di leggi e procedure aziendali di cui si sia venuti a conoscenza nel proprio contesto lavorativo.</p>
<p>Il contenuto di questa pagina viene gestito dall'area amministrativa. Puoi inviare una segnalazione dalla pagina <a href="/whistleblowing">Whistleblowing</a>.</p>`,
    color: 'from-red-500 to-red-600'
  },
  'codice-etico': {
    icon: Scale,
    minStored: 1,
    defaultTitle: 'Codice Etico',
    defaultContent: `<h2>Codice Etico</h2>
<p>Il documento è in corso di pubblicazione: il testo e il relativo PDF vengono caricati dall'area amministrativa del sito.</p>`,
    color: 'from-slate-600 to-slate-700'
  },
  'modello-231': {
    icon: FileText,
    minStored: 1,
    defaultTitle: 'Modello 231',
    defaultContent: `<h2>Modello di organizzazione, gestione e controllo (D.Lgs. 231/2001)</h2>
<p>Il documento è in corso di pubblicazione: il testo e il relativo PDF vengono caricati dall'area amministrativa del sito.</p>`,
    color: 'from-slate-600 to-slate-700'
  }
};

export const CompliancePage = () => {
  const { type } = useParams();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const config = complianceConfig[type] || complianceConfig.privacy;
  const Icon = config.icon;

  useEffect(() => {
    loadPageData();
  }, [type]);

  const loadPageData = async () => {
    setLoading(true);
    try {
      const response = await complianceAPI.getByType(type);
      setPageData(response.data);
    } catch (error) {
      // Use default content if page not found
      setPageData(null);
    } finally {
      setLoading(false);
    }
  };

  const title = pageData?.title || config.defaultTitle;
  // Fall back to the built-in text if the stored page is empty or a leftover placeholder
  const storedContent = pageData?.content || '';
  const plainLength = storedContent.replace(/<[^>]+>/g, ' ').trim().length;
  const content = plainLength >= (config.minStored ?? 400) ? storedContent : config.defaultContent;
  const pdfUrl = pageData?.pdf_url;

  return (
    <div className="min-h-screen pt-20" data-testid={`compliance-page-${type}`}>
      {/* Hero Section */}
      <section className={`relative py-20 bg-gradient-to-r ${config.color} overflow-hidden`}>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-float"></div>
        </div>
        
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl mx-auto text-center"
          >
            <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-white/20 flex items-center justify-center backdrop-blur-sm">
              <Icon className="w-10 h-10 text-white" />
            </div>
            <h1 className="font-display font-bold text-5xl lg:text-6xl mb-6 text-white">
              {title}
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {loading ? (
              <div className="text-center py-12">
                <div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full mx-auto"></div>
                <p className="mt-4 text-muted-foreground">Caricamento...</p>
              </div>
            ) : (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
              >
                <Card className="glass-card">
                  <CardContent className="pt-8 pb-8">
                    <RichTextDisplay content={content} className="prose-lg" />
                    
                    {pdfUrl && (
                      <div className="mt-8 pt-8 border-t border-border">
                        <div className="flex items-center justify-between flex-wrap gap-4">
                          <div className="flex items-center space-x-3">
                            <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                              <FileText className="w-6 h-6 text-primary" />
                            </div>
                            <div>
                              <p className="font-medium text-foreground">Documento PDF</p>
                              <p className="text-sm text-muted-foreground">Scarica la versione completa</p>
                            </div>
                          </div>
                          <Button asChild>
                            <a href={getUploadUrl(pdfUrl)} target="_blank" rel="noopener noreferrer" download>
                              <Download className="w-4 h-4 mr-2" />
                              Scarica PDF
                            </a>
                          </Button>
                        </div>
                      </div>
                    )}
                  </CardContent>
                </Card>
              </motion.div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CompliancePage;
